import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import AnnouncementModal from '../../utils/announcementModal.jsx';

const Announcements = () => {
    const [announcements, setAnnouncements] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);


    const fetchAnnouncements = async (id) => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/getAnnouncementByUser/${id}?showAll=false`);
            setAnnouncements(response.data.data);
        } catch (error) {
            console.error("Error fetching announcements", error);
            setAnnouncements([]);
        }
    };

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('userInfo'));
        fetchAnnouncements(user.id);
    }, []);

    const viewAnnouncementModal = (announcement) => {
        setSelectedAnnouncement(announcement);
        setShowModal(true);
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedAnnouncement(null)
    };

    
    return (
        <>
            <span className="me-1 notification_item">
                <Link href="#" className="notification_icon position-relative me-1" 
                        id="notification_popup" data-bs-toggle="dropdown" aria-expanded="true">
                    <i className="fa fa-bullhorn text-white"></i>
                    <span className="notification-status-dot"></span>
                </Link>
                <div className="dropdown-menu dropdown-menu-end notification-dropdown p-4"  data-popper-placement="bottom-end"
                        style={{width: '400px', maxHeight: '600px', overflow: 'auto'}} role="menu" aria-labelledby="notification_popup">
                    <div className="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
                        <h4 className="notification-title">Announcements ({announcements.length})</h4>
                    </div>
                    <div className="noti-content">
                        <div className="d-flex flex-column">
                            {announcements.length > 0 ? (
                                announcements.map((announcement, index) => (
                                    <div key={index} className="border-bottom mb-3 pb-3">
                                        <a className="d-flex justify-content-between" onClick={() => viewAnnouncementModal(announcement)}>
                                            <span className="text-primary fw-semibold">{announcement.subject || ""} </span>                                        
                                        </a>
                                        <small className="text-muted mb-1 fst-italic"> {announcement.date || ""}</small>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center">No announcement available</div>
                            )}
                        </div>
                    </div>
                    <div className="text-center mt-3">
                        <Link to="/all-announcements" className="h6">View All</Link>
                    </div>
                </div>
            </span>

            {selectedAnnouncement && (
                <AnnouncementModal 
                    showModal={showModal}
                    handleCloseModal={handleCloseModal}
                    data={selectedAnnouncement}
                />
            )}
        </>
    );
}

export default Announcements